<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>The River Below</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<p class="dedication"><em>For Hazel Dixon-Cooper and Wendy Cooper,<br/> and to the river</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?612c2fc2